import routes from "@/routes";
import { lazy } from "react";

const CbmBeta = lazy(() => import("@/modules/Report/CbmBeta"));

const CbmBetaRoutes = {
  element: <CbmBeta />,
  path: routes.REPORTS.CBM_BETA.INDEX,
};

export default CbmBetaRoutes;
